class ReactFormatterLettersTypeFormat extends React.Component {

    constructor(props) {
        super(props);
        this._formattedTypes = {
            'sponsor': 'Sponsor to Child',
            'child': 'Child to Sponsor',
        };
    }

    render(){
        return (
            <span>
                {this._formattedTypes[this.props.value]}
            </span>
        )
    }
}